<script>
/* eslint no-unused-vars: 'off', no-unreachable: 'off' */

import commonModelHelper from '@/scripts/commonModelHelper';
import current from '@/scripts/current';
import common from '@/scripts/common';

function getResetClickedMethod(isFor, forReport) {
    const showForMyAnalysis =
        isFor === 'myAnalysis' &&
        !forReport &&
        current.selectionModel.currentStep !== 'years';
    const showForReport = isFor === 'header' && forReport;
    if (showForMyAnalysis || showForReport)
        return (e) => current.resetClicked(e);
    else return null;
}

export default {
    props: {
        isFor: { default: 'header' },
        forReport: { default: false }
    },
    render(h) {
        const vm = this;
        const isFor = vm.isFor;
        var buttons = [];
        // if (vm.isFor === 'header' && vm.forReport)
        //   buttons.push(
        //     common.createButton(
        //       h,
        //       vm.exportXlsx,
        //       'Download' + '\xa0' + 'Results',
        //       true
        //     )
        //   );
        //buttons.push(createButton(h, vm.jumpToHelp, 'Help'));
        if (isFor === 'header') {
            buttons.push(
                common.createButton(
                    h,
                    vm.jumpToMyAnalysis,
                    'My' + '\xa0' + 'Analysis',
                    'show-on-1'
                )
            );
            buttons.push(
                common.createButton(h, vm.jumpToHelp, 'Help', 'show-on-1')
            );
        } else if (isFor === 'myHelp' || isFor === 'myAnalysis')
            buttons.push(
                common.createButton(h, vm.jumpToBody, vm.bodyName, 'show-on-1')
            );

        const resetClicked = getResetClickedMethod(isFor, vm.forReport);
        if (resetClicked)
            buttons.push(common.createButton(h, resetClicked, 'Reset'));
        return <div class="the-wrapper">{buttons}</div>;
    },
    created: function () {
        const vm = this;
        vm.lowerIsFor = !vm.isFor ? 'select' : vm.isFor.toLowerCase();
        vm.showDownload = Boolean(vm.lowerIsFor === 'report');

        if (vm.forReport) {
            vm.bodyID = 'reportHeader';
            vm.bodyName = 'Report';
        } else {
            vm.bodyID = 'selectionHeader';
            vm.bodyName = 'Select';
        }
        // if (vm.forReport && vm.isFor === "header") {
        //   vm.bodyID = "reportHeader";
        //   vm.bodyName = "Report";
        // } else if (vm.forReport) {
        //   vm.bodyID = vm.isFor + "Header";
        //   vm.bodyName = "Report";
        // } else if (vm.isFor === "header") {
        //   vm.bodyID = "selectionHeader";
        //   vm.bodyName = "Select";
        // } else {
        //   vm.bodyID = vm.isFor + "Header";
        //   vm.bodyName = "Select";
        // }
    },
    data: function () {
        return {
            hyperlinks: [],
            lowerIsFor: null,
            showDownload: false,
            bodyID: '',
            bodyName: ''
        };
    },
    methods: {
        jumpToMyAnalysis,
        jumpToHelp,
        jumpToBody
    }
};

function jumpToMyAnalysis($event) {
    const vm = this;
    if ($event) {$event.preventDefault();}
    let appNavigator = getAppNavigator(vm);
    if (appNavigator) {
        commonModelHelper.jumpTo(
            $event,
            appNavigator.$refs.myAnalysis,
            'myAnalysis'
        );
    }
}

function getAppNavigator(vm) {
    let appNavigator = vm.$parent.$parent.$refs.appNavigator;
    if (!appNavigator) appNavigator = vm.$parent.$refs.appNavigator;
    return appNavigator;
}

function jumpToHelp($event) {
    const vm = this;
    let appNavigator = getAppNavigator(vm);
    if (appNavigator) {
        commonModelHelper.jumpTo($event, appNavigator.$refs.help, 'help');
    }
}
function jumpToBody($event) {
    const vm = this;
    const bodyHeader = document.getElementById(vm.bodyID);
    commonModelHelper.jumpToElement($event, bodyHeader);
}
</script>

<style scoped>
.the-wrapper {
    /* display: inline-block; */
    float: right;
}

.the-wrapper button {
    position: relative;
    width: auto;
}

@media (min-width: 768px) {
    .show-on-1 {
        display: none;
    }
}

@media (max-width: 400px) {
    .the-wrapper {
        width: 100%;
        float: none;
    }
}

@media print {
    .the-wrapper {
        display: none;
    }
}
</style>
